import { useState, useEffect, useCallback } from 'react';
import API from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Inbox, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

export function GmailSyncBar({ onSynced }) {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => API.get('/gmail-sync/status').then(r => setSt(r.data)).catch(() => setSt(null)), []);
  useEffect(() => { load(); }, [load]);
  const reconnect = async () => { const r = await API.get('/auth/google/start'); window.location.href = r.data.auth_url; };
  const run = async () => {
    setBusy(true);
    try {
      const r = await API.post('/gmail-sync/run');
      toast.success(`Inbox checked: ${r.data.replies} new repl${r.data.replies === 1 ? 'y' : 'ies'}, ${r.data.bounces} bounce${r.data.bounces === 1 ? '' : 's'}`);
      load(); onSynced?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Sync failed'); }
    setBusy(false);
  };
  if (!st) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-2.5" data-testid="gmail-sync-bar">
      <Inbox className="h-4 w-4 text-[#0073ea]" />
      <p className="flex-1 min-w-[200px] text-xs text-gray-600" data-testid="gmail-sync-status">
        {st.read_access
          ? <>Reply & bounce tracking on for <b>{st.email}</b> · checks every 15 min · last checked {st.last_synced_at ? new Date(st.last_synced_at).toLocaleString() : 'never'}</>
          : <>Reconnect Google to turn on reply & bounce tracking for email campaigns. The app needs read access to your inbox.</>}
      </p>
      {st.read_access
        ? <Button size="sm" variant="outline" className="h-8" onClick={run} disabled={busy} data-testid="gmail-sync-run-btn"><RefreshCw className={`h-3.5 w-3.5 mr-1 ${busy ? 'animate-spin' : ''}`} />Check inbox now</Button>
        : <Button size="sm" className="h-8 bg-[#0073ea] hover:bg-[#0060c2] text-white" onClick={reconnect} data-testid="gmail-reconnect-btn">Reconnect Google</Button>}
    </div>
  );
}
